import PANModal from './PANModal';

export default PANModal;
